<template>
  <div class="w-full p-4">
    <AuthForm ref="formRef" :model="form" :rules="rules" tone="app">
      <a-form-item name="mobile">
        <a-input v-model:value="form.mobile" placeholder="请输入手机号" size="large" class="w-full h-11" @press-enter="$emit('submit')" />
      </a-form-item>
      <a-form-item name="code">
        <a-input-group compact>
          <a-input v-model:value="form.code" placeholder="请输入验证码" size="large" class="flex-1 h-11" @press-enter="$emit('submit')" />
          <a-button type="primary" size="large" :disabled="codeCountdown > 0" @click="$emit('send-code')" class="h-11">
            {{ codeCountdown > 0 ? `${codeCountdown}秒` : '获取验证码' }}
          </a-button>
        </a-input-group>
      </a-form-item>
    </AuthForm>
    <a-button type="primary" size="large" block :loading="loading" @click="$emit('submit')" class="!h-12 mt-6">
      登录
    </a-button>
  </div>
</template>

<script>
import AuthForm from '@/components/AuthForm'

export default {
  name: 'SmsLoginPanel',
  components: { AuthForm },
  props: {
    form: { type: Object, required: true },
    rules: { type: Object, required: true },
    loading: { type: Boolean, default: false },
    codeCountdown: { type: Number, default: 0 }
  },
  emits: ['submit', 'send-code'],
  methods: {
    validate () {
      return this.$refs.formRef.validate()
    },
    clearValidate () {
      this.$refs.formRef?.clearValidate()
    }
  }
}
</script>
